export default function PHP_ReferenceVariableHandling() {
  return (
    <div>
      <h1>PHP_ReferenceVariableHandling</h1>
    </div>
  );
}
